import * as preact from 'preact'
const { h, Component } = preact
import * as style from './style.css'
import PureComponent from '../../../lib/preact-pure-component'
import * as classNames from 'classnames'

interface Props {
  active?: boolean
  style?: string
  fadeClasses: string
}

export class Black extends PureComponent<Props, {}> {
  render() {
    const classes = classNames(style.black, this.props.fadeClasses, {
      [style.solidColor]: this.props.style && this.props.style.indexOf('solidColor') > -1
    })
    return <div className={classes} />
  }
}
